import React from 'react';
import { Phone, DollarSign, Home, Layers, TrendingUp } from 'lucide-react';
const PHONE = '586-203-3701';
export function CostSection() {
  const tiers = [{
    Icon: Home,
    label: 'Small Home',
    size: '~1,200 sq ft roof',
    price: '$8,500 – $13,000',
    detail: 'Standard 3-tab or architectural shingles, single layer tear-off.'
  }, {
    Icon: Layers,
    label: 'Average Home',
    size: '~1,800 sq ft roof',
    price: '$12,500 – $20,000',
    detail: 'Premium architectural shingles, full underlayment & ice shield.',
    featured: true
  }, {
    Icon: TrendingUp,
    label: 'Larger Home',
    size: '2,500+ sq ft roof',
    price: '$18,000 – $32,000+',
    detail: 'Designer or impact-rated shingles, complex rooflines, multiple stories.'
  }];
  return <section className="bg-white py-20 sm:py-24" data-id="element-29">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-30">
        <div className="text-center max-w-3xl mx-auto mb-12" data-id="element-31">
          <span className="inline-block text-[#2DB8E0] font-bold uppercase tracking-wider text-sm mb-4" data-id="element-32">
            Honest Pricing
          </span>
          <h2 className="font-display italic text-4xl sm:text-5xl text-[#1a2332] leading-tight mb-4" data-id="element-33">
            How Much Does a Roof Replacement Cost in Michigan?
          </h2>
          <p className="text-lg text-slate-600" data-id="element-34">
            Every home is different — but here are honest ranges so you know
            what to expect. Your free Moceri inspection gives you an exact,
            written quote in writing with no pressure.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-6 mb-10" data-id="element-35">
          {tiers.map(t => <div key={t.label} className={`rounded-2xl p-7 border transition-all ${t.featured ? 'bg-[#1a2332] text-white border-[#2DB8E0] shadow-xl scale-100 md:scale-105' : 'bg-white text-[#1a2332] border-slate-200 shadow-sm'}`} data-id="element-36">
              <div className={`w-12 h-12 rounded-full flex items-center justify-center mb-4 ${t.featured ? 'bg-[#2DB8E0]' : 'bg-[#2DB8E0]/10'}`} data-id="element-37">
                <t.Icon className={`w-6 h-6 ${t.featured ? 'text-white' : 'text-[#2DB8E0]'}`} data-id="element-38" />
              </div>
              <h3 className="font-bold text-xl mb-1" data-id="element-39">{t.label}</h3>
              <p className={`text-sm mb-4 ${t.featured ? 'text-white/70' : 'text-slate-500'}`} data-id="element-40">
                {t.size}
              </p>
              <div className="flex items-baseline gap-1 mb-3" data-id="element-41">
                <span className="font-display italic text-3xl sm:text-4xl font-medium" data-id="element-42">
                  {t.price}
                </span>
              </div>
              <p className={`text-sm leading-relaxed ${t.featured ? 'text-white/80' : 'text-slate-600'}`} data-id="element-43">
                {t.detail}
              </p>
            </div>)}
        </div>

        <div className="bg-slate-50 rounded-2xl p-6 sm:p-8 flex flex-col md:flex-row items-center justify-between gap-5" data-id="element-44">
          <div className="flex items-start gap-4" data-id="element-45">
            <DollarSign className="w-10 h-10 text-[#2DB8E0] flex-shrink-0" data-id="element-46" />
            <div data-id="element-47">
              <h4 className="font-bold text-[#1a2332] text-lg mb-1" data-id="element-48">
                Financing available — make it affordable.
              </h4>
              <p className="text-slate-600 text-sm" data-id="element-49">
                We work with financing partners offering low monthly payments
                and 0% promotional terms on approved credit. Ask about it during
                your free inspection.
              </p>
            </div>
          </div>
          <div className="flex flex-col sm:flex-row gap-3 flex-shrink-0" data-id="element-50">
            <a href="#quote-form" className="inline-flex items-center justify-center bg-[#2DB8E0] hover:bg-[#1a9cc4] text-white font-bold px-6 py-3 rounded-full transition-colors whitespace-nowrap" data-id="element-51">
              Get My Exact Quote
            </a>
            <a href={`tel:${PHONE.replace(/-/g, '')}`} className="inline-flex items-center justify-center gap-2 border-2 border-[#1a2332] text-[#1a2332] hover:bg-[#1a2332] hover:text-white font-bold px-5 py-3 rounded-full transition-colors whitespace-nowrap" data-id="element-52">
              <Phone className="w-4 h-4" data-id="element-53" /> {PHONE}
            </a>
          </div>
        </div>
      </div>
    </section>;
}